
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 510 510"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M255 0C114.75 0 0 114.75 0 255s114.75 255 255 255 255-114.75 255-255S395.25 0 255 0zm25.5 433.5h-51v-51h51v51zm53.55-196.35L311.1 260.1c-20.399 17.851-30.6 33.15-30.6 71.4h-51v-12.75c0-28.05 10.2-53.55 30.6-71.4l30.6-33.15c10.2-7.65 15.3-20.4 15.3-35.7 0-28.05-22.95-51-51-51s-51 22.95-51 51h-51c0-56.1 45.9-102 102-102s102 45.9 102 102c0 22.95-10.2 43.35-22.95 58.65z"}})])
          )
        }
      }
    